import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorLogService } from '../../../services/error-log.service';
import {DialogService} from 'primeng/dynamicdialog';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-error-log-view-modal',
  templateUrl: './error-log-view-modal.component.html',
  styleUrls: ['./error-log-view-modal.component.css'],
  providers: [DialogService, ConfirmationService, MessageService],

})
export class ErrorLogViewModalComponent implements OnInit{
errorLogDetail:any;
idFromParent: number;

  constructor(
    private spinner: NgxSpinnerService,
    private errorLogService: ErrorLogService,
    public ref: DynamicDialogRef, 
    public config: DynamicDialogConfig,
    private dialogService: DialogService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
  ) { 
    this.idFromParent = config.data.id;

   }

  ngOnInit(): void {
    this.getIndividualNLogRecordDetails();
  }
  getIndividualNLogRecordDetails(){
    this.errorLogService.getIndividualNLogRecordDetails(this.idFromParent).subscribe((data: any) => {
      this.errorLogDetail = data[0];
      console.log('data',this.errorLogDetail);
     });
  }
}
